export const suggestionsForTermQuery = `
  {
    "query": {
      "match": {
        "value": {
          "query": "<%=userInput%>",
          "operator": "and"
        }
      }
    },
    "aggs": {
      "top_values": {
        "filter": {
          "match_all": {}
        },
        "aggs": {
          "by_value": {
            "terms": {
              "field": "value.precise",
              "size": <%=maxCount%>
            },
            "aggs": {
              "known_categories": {
              "terms": {
                "field": "category",
                  "size": <%=maxCount%>
              }
            }
            }

          }
        }
      }
    },
    "sort": [
      "_score"
    ],
    "size": <%=maxCount%>
  }
  `;
